<template>
  <div class="all">
    <!-- 底部 -->
    <mall-fotter></mall-fotter>
    <!-- 顶部导航 -->
    <mall-header ref="header"></mall-header>
    <!-- 内容 -->
    <div class="content">
      <div class="content_detail">
        <!-- 顶部标题 -->
        <div class="pageTitle ovh">
          <div class="pageTitleList f_l ovh" @click="goIndex">
            <p class="pageTitleListTable f_l">首页</p>
            <div class="pageTitleListImg f_l">
              <img src="../../static/index/right.png" />
            </div>
          </div>
          <div class="pageTitleList f_l ovh">
            <p class="pageTitleListTable f_l">商家入驻</p>
            <div class="pageTitleListImg f_l">
              <img src="../../static/index/right.png" />
            </div>
          </div>
        </div>
        <!-- 输入框标题 -->
        <div class="title ovh">
          <div class="f_l"></div>
          <div class="f_l">商家运营管理人基本信息</div>
        </div>
        <!-- 输入框 -->
        <div class="inputAll ovh">
          <div class="inputTable f_l txt_a_r"><span>*</span>商家管理人姓名：</div>
          <el-input class="f_l input" v-model="user_name" placeholder="商家管理人姓名" clearable></el-input>
        </div>
        <div class="inputAll ovh">
          <div class="inputTable f_l txt_a_r"><span>*</span>商家管理人邮箱：</div>
          <el-input class="f_l input" v-model="email" placeholder="商家管理人邮箱" clearable></el-input>
        </div>
        <div class="inputAll ovh">
          <div class="inputTable f_l txt_a_r"><span>*</span>商家管理人手机号：</div>
          <el-input class="f_l input" v-model="phone" placeholder="商家管理人手机号" maxlength="11" clearable></el-input>
        </div>
        <!-- 输入框标题 -->
        <div class="title ovh">
          <div class="f_l"></div>
          <div class="f_l">企业法定代表人基本信息</div>
        </div>
        <!-- 输入框 -->
        <div class="inputAll ovh">
          <div class="inputTable f_l txt_a_r"><span>*</span>法定代表人姓名：</div>
          <el-input class="f_l input" v-model="legal_person" placeholder="法定代表人姓名" clearable></el-input>
        </div>
        <div class="inputAll ovh">
          <div class="inputTable f_l txt_a_r"><span>*</span>法定代表人手机号：</div>
          <el-input class="f_l input" v-model="legal_phone" placeholder="法定代表人手机号" maxlength="11" clearable></el-input>
        </div>
        <div class="inputAll ovh">
          <div class="inputTable f_l txt_a_r"><span>*</span>法定代表人身份证件号：</div>
          <el-input class="f_l input" v-model="legal_idNumber" placeholder="法定代表人身份证件号" clearable></el-input>
        </div>
        <div class="inputAll ovh">
          <div class="inputTable f_l txt_a_r"><span>*</span>法定代表人身份证件有效期：</div>
          <el-date-picker
              class="f_l input"
              v-model="validity_date"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="法定代表人身份证件有效期"
              style="width: 291px;margin-right: 20px;"
              clearable>
          </el-date-picker>
        </div>
        <div class="inputAll ovh">
          <div class="inputTable f_l txt_a_r"><span>*</span>法定代表人身份证件正反面：</div>
          <div class="update f_l ovh">
            <el-upload
              class="avatar-uploader f_l"
              action="#"
              :show-file-list="false"
              :http-request="idCardFrontFile">
              <div class="up_img">
                <img v-if="isIdCardFrontFileCode == 0" src="../../static/index/update.png">
                <img v-if="isIdCardFrontFileCode == 1" :src="idCardFront" />
              </div>
            </el-upload>
            <el-upload
              class="avatar-uploader f_l"
              action="#"
              :show-file-list="false"
              :http-request="idCardReverseFile">
              <div class="up_img">
                <img v-if="isIdCardReverseFileCode == 0" src="../../static/index/update.png">
                <img v-if="isIdCardReverseFileCode == 1" :src="idCardReverse" />
              </div>
            </el-upload>
          </div>
        </div>
        <div class="inputAll ovh">
          <div class="inputTable f_l txt_a_r"><span></span></div>
          <div class="buttonList f_l ovh">
            <!-- <div class="f_l txt_a_c">修改</div> -->
            <div class="f_l txt_a_c" @click="submit">提交</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // 引入共用的css
	import "../components/css/component.css";

  // 顶部导航
  import mallHeader from '@/components/headTop.vue';
  // 底部
  import mallFotter from '@/components/fotter.vue';

  // 调用的接口
  import { merchantSettlement, idCardUpload } from '@/request/api.js';
  import { isMobile, isEmail, isIdCard } from '@/utils/utils.js'
  import { baseUrl } from '@/request/request.js'

  export default {
    name: 'business',
    data () {
      return {
        user_name: '', // 商家管理人姓名
        email: '', // 商家管理人邮箱
        phone: '', // 商家管理人手机号
        legal_person: '', // 法定代表人姓名
        legal_phone: '', // 法定代表人手机号
        legal_idNumber: '', // 法定代表人身份证件号
        validity_date: '', // 法定代表人身份证件有效期
        legal_pic: '', // 法定代表人身份证件正反面
        isIdCardFrontFileCode: 0, // 身份证正面
        idCardFront: '', // 身份证正面
        isIdCardReverseFileCode: 0, // 身份证反面
        idCardReverse: '' // 身份证反面
      }
    },

    // 引用顶部和底部
    components:{
      'mall-header': mallHeader, // 顶部导航
      'mall-fotter': mallFotter // 底部导航
    },

    mounted() {
      // 页面跳转拿值
      // console.log(this.$route.params);
      // 导航选择
      this.navigation(3);
      // 判断用户是否登录
      var name = localStorage.getItem('userName');
      if(name == null || name == 'null' || name == '' || name == undefined) {
        this.$message({
          showClose: true,
          message: '请在登录后查看'
        });
      }
    },

    computed:{
      
    },

    methods:{
      // 点击提交按钮
      submit() {
        // 非空判断
        if(this.user_name == '') {
          this.$message({
            showClose: true,
            message: '请填写商家管理人姓名'
          });
          return;
        }
        if(this.email == '') {
          this.$message({
            showClose: true,
            message: '请填写商家管理人邮箱'
          });
          return;
        }
        if(this.phone == '') {
          this.$message({
            showClose: true,
            message: '请填写商家管理人手机号'
          });
          return;
        }
        if(this.legal_person == '') {
          this.$message({
            showClose: true,
            message: '请填写法定代表人姓名'
          });
          return;
        }
        if(this.legal_phone == '') {
          this.$message({
            showClose: true,
            message: '请填写法定代表人手机号'
          });
          return;
        }
        if(this.legal_idNumber == '') {
          this.$message({
            showClose: true,
            message: '请填写法定代表人身份证件号'
          });
          return;
        }
        if(this.validity_date == '') {
          this.$message({
            showClose: true,
            message: '请填写法定代表人身份证件有效期'
          });
          return;
        }
        if(this.idCardFront == '' || this.idCardReverse == '') {
          this.$message({
            showClose: true,
            message: '请上传法定代表人身份证件'
          });
          return;
        }
        if(!isEmail(this.email)) {
          this.$message({
            showClose: true,
            message: '商家管理人邮箱格式错误'
          });
          return;
        }
        if(!isMobile(this.phone)) {
          this.$message({
            showClose: true,
            message: '商家管理人手机号格式错误'
          });
          return;
        }
        if(!isMobile(this.legal_phone)) {
          this.$message({
            showClose: true,
            message: '法定代表人手机号格式错误'
          });
          return;
        }
        if(!isIdCard(this.legal_idNumber)) {
          this.$message({
            showClose: true,
            message: '法定代表人身份证件号格式错误'
          });
          return;
        }
        // 判断用户是否登录
        var name = localStorage.getItem('userName');
        if(name == null || name == 'null' || name == '' || name == undefined) {
          this.$message({
            showClose: true,
            message: '请先登录'
          });
          return;
        }
        // 调用商家入驻保存接口
        merchantSettlement({
          user_name: this.user_name, // 商家管理人姓名
          email: this.user_name, // 商家管理人邮箱
          phone: this.user_name, // 商家管理人手机号
          legal_person: this.user_name, // 法定代表人姓名
          legal_phone: this.user_name, // 法定代表人手机号
          legal_idNumber: this.user_name, // 法定代表人身份证件号
          validity_date: this.user_name, // 法定代表人身份证件有效期
          legal_pic: this.idCardFront + ',' + this.idCardReverse, // 法定代表人身份证件正反面
          token: localStorage.getItem('token')
        }).then(res => {
          if(res.code == 0) {
            this.$message({
              type: 'success',
              message: '入驻成功'
            });
            // 跳转首页
            this.$router.push({
              name: 'index',
              params: {}
            })
          }else {
            this.$message({
              type: 'error',
              message: res.message
            });
          }
        })
      },

      // 身份证正面
      idCardFrontFile(row) {
        // 表单
        var file = row.file;
        // 文件类型
        const isJPG = file.type;
        // 文件大小
        const isLt2M = file.size / 1024 / 1024 < 2;
        // 文件格式不正确停止运行
        if (isJPG !== 'image/jpeg' && isJPG !== 'image/png' && isJPG !== 'image/jpg') {
          this.$message.error('上传头像图片只能是 JPG/PNG/JPEG 格式!');
          return;
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
          return
        }
        // 新建表单
        let param = new FormData();
        // 传文件
				param.append("photo", file);
        param.append("token", localStorage.getItem('token'));
        // 调用图片上传接口
        idCardUpload(param).then(res => {
          if(res.code == 0) {
            this.isIdCardFrontFileCode = 1;
            // 正面地址赋值
            this.idCardFront = baseUrl() + res.data.path;
          }
        })
      },

      // 身份证反面
      idCardReverseFile(row) {
        // 表单
        var file = row.file;
        // 文件类型
        const isJPG = file.type;
        // 文件大小
        const isLt2M = file.size / 1024 / 1024 < 2;
        // 文件格式不正确停止运行
        if (isJPG !== 'image/jpeg' && isJPG !== 'image/png' && isJPG !== 'image/jpg') {
          this.$message.error('上传头像图片只能是 JPG/PNG/JPEG 格式!');
          return;
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
          return
        }
        // 新建表单
        let param = new FormData();
        // 传文件
				param.append("photo", file);
        param.append("token", localStorage.getItem('token'));
        // 调用图片上传接口
        idCardUpload(param).then(res => {
          if(res.code == 0) {
            this.isIdCardReverseFileCode = 1;
            // 正面地址赋值
            this.idCardReverse = baseUrl() + res.data.path;
          }
        })
      },

      // 导航选择
      navigation(code) {
        this.$nextTick(() => {
          this.$refs.header.init(code)
        })
      },

      // 点击返回首页
      goIndex() {
        this.$router.push({
          name: 'index',
          params: {}
        })
      },
    }
  }
</script>

<!-- 样式 -->
<style scoped lang="scss">
  .content {
    padding: 50px 0 530px 0;
    &> .content_detail {
      width: 1200px;
      margin: 0 auto;
      // 页面标题
      &> .pageTitle {
        padding: 36px 0 20px 0;
        &> .pageTitleList {
          margin-right: 48px;
          &> .pageTitleListTable {
            color: #434444;
            font-size: 24px;
          }
          &> .pageTitleListImg {
            margin-left: 18px;
            width: 14px;
            height: 20px;
            margin-top: 7px;
          }
        }
        &> .pageTitleList:first-child > .pageTitleListTable {
          color: #0F7DFF;
          cursor: pointer;
        }
      }
      // 标题
      &> .title {
        font-size: 22px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 40px;
        border-bottom: 4px solid #D8D8D8;
        letter-spacing: 1px;
        margin-bottom: 20px;
        margin-top: 19px;
        &> div:first-child {
          width: 5px;
          height: 27px;
          background: #0F7DFF;
          border-radius: 1px;
          margin-top: 7px;
          margin-right: 11px;
        }
      }
      // 输入框
      &> .inputAll {
        &> .inputTable {
          width: 270px;
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 25px;
          letter-spacing: 1px;
          height: 70px;
          line-height: 70px;
          span {
            color: #FF0000;
          }
        }
        &> .input {
          width: 291px;
          height: 25px;
          margin: 15px 0 0 30px;
        }
        &> .update {
          margin-left: 30px;
          &> .up_img {
            width: 109px;
            height: 109px;
            margin-right: 14px;
          }
          &> .up_img:last-child {
            margin-right: 0;
          }
        }
        &> .buttonList {
          width: 291px;
          margin: 41px 0 41px 30px;
          &> div {
            font-size: 16px;
            width: 104px;
            height: 40px;
            line-height: 40px;
            border-radius: 2px;
            color: #fff;
            border-radius: 8px;
            cursor: pointer;
            letter-spacing: 2px;
          }
          &> div:first-child {
            background: #979797;
          }
          &> div:last-child {
            background: #0F7DFF;
          }
        }
      }
    }
  }
  .up_img {
    width: 109px;
    height: 109px;
    margin-right: 14px;
    border-radius: 4px;
    overflow: hidden;
  }
  .el-carousel__item.is-active {
    z-index: 0;
  }
  input{outline:show !important;}
</style>
<style scoped lang="">
  /deep/ .f_l > input:focus{border: 1px solid #DCDFE6 !important;}
</style>



// WEBPACK FOOTER //
// src/page/business.vue